import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";

function Pagination(props){
  if(props.pages > 1)
  {
    return (<ul className="pagination">
          <li><Link to={'/blog/'}>First</Link></li>
          {props.pl.map(function(i){
            return <li key={'pagkey' + i.number} className={i.status}><Link to={'/blog/' + (i.number > 1 ? i.number : '')}>{i.number}</Link></li>;
          })}
          <li><Link to={'/blog/' + props.max}>Last</Link></li>
        </ul>);
  }
  else
  {
    return null;
  }
}

export default function Index({ data, pathContext }) {

  const { edges: posts } = data.allMarkdownRemark;
  const fin = [];
  const per = pathContext.per ? pathContext.per : 3;
  const min = pathContext.per ? (pathContext.per * pathContext.page) - pathContext.per : 0;
  const max = pathContext.per ? min + pathContext.per : 2;

  for(var i = 0; i < posts.length; i ++)
  {
    if(i >= min && i <= max)
    {
      fin.push(posts[i]);      
    }
  }

  var pl = [];
  for(var i = 1; i <= Math.ceil(data.allMarkdownRemark.totalCount / per); i ++)
  {
    pl.push({number: i, status: ((pathContext.page && pathContext.page == i) || (!pathContext.page && i == 1) ? 'current' : '')});
  }
  

  return (
    <div className="page-wrapper">
      <Helmet title={`Blog of much banalities`} />
      <section className="blog-hero">
        <h1>Blog of much banalities</h1>
        <p>Ugh... read on if you can stand it. (page {pathContext.page ? pathContext.page : 1})</p>
      </section>   
      <div className="blog-posts">   
      {fin
        .filter(post => post.node.frontmatter.title.length > 0)
        .map(({ node: post }) => {
          return (
            <div className="blog-post-preview" key={post.id}>
             <Link to={post.frontmatter.path} className="blog-image" style={{backgroundImage: 'url(' + post.frontmatter.image + ')'}}><img src={post.frontmatter.image} alt={post.frontmatter.title} /><span className="date">{post.frontmatter.date}</span></Link>
              <h2>
                <Link to={post.frontmatter.path}>{post.frontmatter.title}</Link>
              </h2>
              <p>{post.excerpt}</p>
            </div>
          );
        })}
      </div>
      <Pagination pages={Math.ceil(data.allMarkdownRemark.totalCount / per)} pl={pl} max={Math.ceil(data.allMarkdownRemark.totalCount / per)} />
    </div>
  );
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___date] }
      ) {
      totalCount
      edges {
        node {
          excerpt(pruneLength: 250)
          id
          frontmatter {
            title
            image
            date(formatString: "MMMM DD, YYYY")
            path
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/blog.js